<template>
  <v-container fluid>
    <card class='stripe-card'
      :class='{ complete }'
      stripe='pk_test_ZTQDDJOtBsbpOYcNwG2RUvKT'
      :options='stripeOptions'
      @change='complete = $event.complete'
    />
  </v-container>
</template>

<script>
import { Card, createToken } from 'vue-stripe-elements-plus';

export default {
    name: 'Stripe',
    data() {
        return {
            complete: false,
            stripeOptions: {
                // see https://stripe.com/docs/stripe.js#element-options for details
                base: {
                    color: '#32325D',
                    fontWeight: 500,
                    fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
                    fontSize: '30px',
                    fontSmoothing: 'antialiased',

                    '::placeholder': {
                        color: '#CFD7DF',
                    },
                    ':-webkit-autofill': {
                        color: '#e39f48',
                    },
                },
                invalid: {
                    color: '#E25950',

                    '::placeholder': {
                        color: '#FFCCA5',
                    },
                },
            },
        };
    },

    components: { Card },

    methods: {
        pay() {
            // createToken returns a Promise which resolves in a result object with
            // either a token or an error key.
            // See https://stripe.com/docs/api#tokens for the token object.
            // See https://stripe.com/docs/api#errors for the error object.
            // More general https://stripe.com/docs/stripe.js#stripe-create-token.
            return createToken();
        },
    },
};
</script>

<style>
.stripe-card {
}
.stripe-card.complete {
    border-color: green;
}
</style>